import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import campeones from "../../Assets/Projects/campeones.png";
import campeones1 from "../../Assets/Projects/campeones1.png";
import campeones2 from "../../Assets/Projects/campeones2.png";
import campeonesmovil from "../../Assets/Projects/campeonesmovil.png";
import campeonesmovil1 from "../../Assets/Projects/campeonesmovil1.png";
import sandroventas from "../../Assets/Projects/sandroventas.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Container>
        <h1 className="project-heading">
          Mis recientes <strong className="purple">proyectos </strong>
        </h1>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col xs={12} sm={6} lg={4} className="project-card">
            <ProjectCard
              images={[sandroventas]}
              isBlog={false}
              title="Proyecto Sandro Ventas - Web"
              summary="Monorepo fullstack para gestión y publicación de vehículos y propiedades. Plataforma completa con catálogo público, API REST y panel de administración."
              description="Monorepo fullstack para gestión y publicación de vehículos y propiedades. Plataforma completa con catálogo público, panel de administración e integración con WhatsApp.
• Catálogo público con Next.js 15 (App Router).
• API REST con Express + Prisma ORM.
• Panel de administración protegido con JWT.
• Integración con WhatsApp para leads.
• Almacenamiento de imágenes en Cloudinary.
• Base de datos PostgreSQL."
              demoLink="https://sandroventas.com/"
              techs={[
                "Next.js",
                "Express",
                "Prisma",
                "PostgreSQL",
                "Cloudinary",
                "JWT",
              ]}
            />
          </Col>
          <Col xs={12} sm={6} lg={4} className="project-card">
            <ProjectCard
              images={[campeones, campeones1, campeones2]}
              isBlog={false}
              title="Proyecto Campeones - Web"
              summary="Tienda online de camisetas de fútbol con dashboard web para administración, gestión de pedidos y métricas de ventas. Desarrollado como práctica profesionalizante en ISPC."
              description="Tienda de Campeones es una tienda online que ofrece camisetas de fútbol de todos los países que han ganado la Copa del Mundo. La aplicación incluye una página web y una aplicación móvil para Android, permite a los usuarios registrarse, iniciar sesión, explorar productos categorizados por país, gestionar sus pedidos a través de un dashboard personalizado, contactar al equipo de soporte y confirmar sus compras de manera sencilla. Desarrollado como práctica profesionalizante en ISPC.
• Desarrollé los dashboards de clientes y administradores con Angular, logrando una interfaz moderna, responsiva y centrada en la experiencia de usuario (UI/UX).
• Implementé autenticación segura mediante JWT, gestionando registro, login y control de acceso por rol.
• Diseñé y optimicé la estructura de base de datos MySQL, mejorando la eficiencia de las consultas y la integridad del sistema.
• Desarrollé lógica de negocio para visualización de métricas (ventas diarias, mensuales y anuales), gestión de pedidos (seguimiento, envío y cancelación) y administración de usuarios (registro, listado, filtrado y cancelación)."
              ghLink="https://github.com/Proyecto-integrador-ISPC-2024/proyecto-integrador-web-pp-2025"
              demoLink=""
              techs={[
                "Angular",
                "TypeScript",
                "Bootstrap",
                "Django",
                "MySQL",
                "Python",
              ]}
            />
          </Col>
          <Col xs={12} sm={6} lg={4} className="project-card">
            <ProjectCard
              images={[campeonesmovil, campeonesmovil1]}
              isBlog={false}
              title="Campeones - Aplicación Móvil"
              summary="Tienda online de camisetas de fútbol con app Android para gestión de pedidos y dashboards personalizados por rol. Desarrollado como práctica profesionalizante en ISPC."
              description="Tienda de Campeones es una tienda online que ofrece camisetas de fútbol de todos los países que han ganado la Copa del Mundo. La aplicación incluye una página web y una aplicación móvil para Android, permite a los usuarios registrarse, iniciar sesión, explorar productos categorizados por país, gestionar sus pedidos a través de un dashboard personalizado, contactar al equipo de soporte y confirmar sus compras de manera sencilla. Desarrollado como práctica profesionalizante en ISPC.
• Desarrollé las interfaces de los dashboards para administradores y clientes en Android nativo, con diseño responsivo y moderno orientado a una experiencia fluida.
• Implementé autenticación de usuarios mediante JWT, con control de accesos y navegación diferenciada según rol.
• Desarrollé funcionalidades para administradores: gestión de usuarios, control de pedidos y visualización de métricas.
• Desarrollé funcionalidades para clientes: historial completo de pedidos y opción de cancelación."
              ghLink="https://github.com/Proyecto-integrador-ISPC-2024/proyecto-integrador-mobile-2024"
              demoLink=""
              techs={["Android", "Java", "Django", "MySQL", "Python"]}
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
